module.exports = __webpack_public_path__ + "static/img/plan1.08c71e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/clix/training-plan/plan1.png
// module id = LqyP
// module chunks = 35